module.exports = __webpack_public_path__ + "img/idp3.6fcb1bc4.jpg";